import React from 'react';

const KeyIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.3335 6.99992L14.6669 4.66659M16.0002 3.33325L14.6669 4.66659L16.0002 3.33325ZM9.59352 9.73992C9.93774 10.0796 10.2114 10.4839 10.3987 10.9298C10.586 11.3756 10.6832 11.8541 10.6849 12.3377C10.6865 12.8213 10.5924 13.3004 10.4081 13.7475C10.2238 14.1945 9.95289 14.6007 9.61095 14.9427C9.269 15.2846 8.8628 15.5556 8.41572 15.7399C7.96864 15.9242 7.48952 16.0182 7.00594 16.0166C6.52236 16.015 6.04388 15.9177 5.59804 15.7304C5.15221 15.5431 4.74783 15.2695 4.40818 14.9253C3.74027 14.2337 3.37069 13.3075 3.37904 12.3461C3.3874 11.3847 3.77302 10.4651 4.45285 9.78525C5.13268 9.10542 6.05232 8.7198 7.01371 8.71145C7.9751 8.70309 8.90131 9.07267 9.59285 9.74058L9.59352 9.73992ZM9.59352 9.73992L12.3335 6.99992L9.59352 9.73992ZM12.3335 6.99992L14.3335 8.99992L16.6669 6.66659L14.6669 4.66659L12.3335 6.99992Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KeyIcon;
